import React from 'react';

interface TextWithLinksProps {
  text: any;
}
export const TextWithLinks: React.FC<TextWithLinksProps> = ({ text }) => {
  if (!text) {
    return text;
  }
  const urlMatcher = /\[(.+)\]\((.+)\)/g;
  const html = text.replace(urlMatcher, '<a href="$2" target="_blank">$1</a>');
  return <span dangerouslySetInnerHTML={{ __html: html }} />;
};
